import { useTranslate } from "helpers";
import { CalculationDetailCardProps } from "./types";
import { CalculationVehicleDetailCard } from "./components/CalculationVehicleDetailCard";
import { CalculationPriceDetailCard } from "./components/CalculationPriceDetailCard";
import { CalculationPriceTotalDetailCard } from "./components/CalculationPriceTotalDetailCard";
import { SectionHeader } from "./components/SectionHeader";

const CalculationDetailCard: React.FC<CalculationDetailCardProps> = (props) => {
  const { vehicleInfo, formValues, setFormValues } = props;
  const { t } = useTranslate();

  return (
    <div className="px-4 pt-12 pb-6">
      <div className="max-w-[1900px] mx-auto">
        <h1 className="text-2xl font-bold text-slate-900 text-center mb-1">
          {t("admin.calculation.detail.step.title")}
        </h1>
        <p className="text-center text-sm text-slate-600 mb-6 max-w-2xl mx-auto ">
          {t("admin.calculation.detail.step.description")}
        </p>

        <div className="flex gap-8 items-start">
          {/* Lijevo: razrada cijene */}
          <div className="w-3/4">
            <div className="">
              <div className="">
                {/* <SectionHeader
                  icon="/media/icons/calculator.svg"
                  title="admin.calculation.detail.section.price"
                  subtitle="Razrada mjesečnih troškova najma vozila"
                /> */}
                <CalculationPriceDetailCard
                  formValues={formValues}
                  setFormValues={setFormValues}
                />
              </div>
            </div>
          </div>

          {/* Desno: vozilo + sažetak */}
          <div className="w-1/4">
            <div className="border bg-white border-slate-200 rounded-xs overflow-hidden sticky top-4">
              <div className="border-b border-slate-200 py-4 px-4">
                {/* <SectionHeader
                  icon="/media/icons/car.svg"
                  title="admin.calculation.detail.section.vehicle"
                  subtitle="Odabrano vozilo i specifikacije"
                /> */}
                <CalculationVehicleDetailCard vehicleInfo={vehicleInfo} />
              </div>
              <div className="py-6 px-4">
                {/* <SectionHeader
                  icon="/media/icons/document.svg"
                  title="admin.calculation.detail.section.summary"
                  subtitle="Pregled ugovornih uvjeta kalkulacije"
                /> */}
                <CalculationPriceTotalDetailCard formValues={formValues} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CalculationDetailCard;
